import 'fancybox-core';
import 'fancybox-media';

/* eslint-disable max-len */
const $fancyboxLinks = $('.fancybox-media, .reviewLink');
const $fancyboxVideoLinks = $(
  '.video-media, .js-video-thumbnail, a[href*="youtube.com/watch?"], a[href*="youtube.com/v/?"]',
);
const $inlineModals = $('.js-modal-inline');
/* eslint-enable max-len */

const self = {
  initialise: () => {
    if ($fancyboxLinks.length) {
      self.applyFancyBox(self.$fancyboxLinks);
    }

    if ($fancyboxVideoLinks.length) {
      self.applyFancyBoxVideo($fancyboxVideoLinks);
    }

    if ($inlineModals.length) {
      self.applyFancyBoxInline($inlineModals);
    }

    $('.productBtn').fancybox({
      width: '365',
      height: '275',
      padding: '20',
      scrolling: 'no',
    });

    // fancybox
    $('a[href*="youtube.com/watch?"]').addClass('fancybox-media');
    $('a[href*="vimeo"]').addClass('fancybox-media');

    self.applyFancyBox($('.fancybox-media'));

    $('.reviewLink').fancybox({
      width: '50%',
      autoSize: false,
    });

    // project centre share popup
    $('.projectTopBanner .shareButton').fancybox({
      beforeShow() {
        $('.fancybox-skin').css('backgroundColor', 'transparent');
      },
      maxWidth: 800,
      maxHeight: 800,
      width: '50%',
      height: '50%',
      closeBtn: true,
      openEffect: 'none',
      closeEffect: 'none',
      margin: 0,
      padding: 0,
      afterShow() {
        $('.fancybox-inner').css('overflow', 'inherit');
      },
    });
  },
  applyFancyBox: $elem => {
    if ($elem) {
      $elem.fancybox({
        closeBtn: true,
        helpers: {
          media: {},
        },
      });
    }
  },
  applyFancyBoxInline: $elem => {
    if (!$elem) {
      return;
    }

    const modalId = $elem.attr('id');
    const sessionKey = `modal-disabled-${modalId}`;

    try {
      const disableModel = sessionStorage.getItem(sessionKey, true);

      if (disableModel) {
        return;
      }

      $.fancybox(`#${modalId}`, {
        padding: 0,
        beforeClose: () => {
          try {
            sessionStorage.setItem(sessionKey, true);
          } catch (e) {
            // ignore
          }
        },
      });
    } catch (e) {
      // ignore
    }
  },
  applyFancyBoxVideo: $elem => {
    if ($elem) {
      $elem.fancybox({
        openEffect: 'none',
        closeEffect: 'none',
        type: 'iframe',
        closeBtn: true,
        width: 1920,
        height: 1080,
        aspectRatio: true,
        padding: 0,
      });
    }
  },
  /** Check if the query string contains playVideo, if so autoplay the video. */
  autoPlayVideo: $elem => {
    const vars = [];
    let hash;
    const hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');

    for (let i = 0; i < hashes.length; i += 1) {
      hash = hashes[i].split('=');
      vars.push(hash[0]);
      vars[hash[0]] = hash[1];
    }

    if (vars.playVideo !== undefined && $elem.hasClass('js-autoplayable')) {
      $elem.click();
    }
  },
};

self.initialise();

if (window.Sys) {
  Sys.WebForms.PageRequestManager.getInstance().add_endRequest(self.initialise);
}

export default self;
